import {BaseException} from "../../BaseException";

export class CouldNotPerformApiCallException extends BaseException {
    public constructor(message: string) {
        super(message);
    }
}
